<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" lg="8" offset-lg="2">
        <v-card raised>
          <!--<v-row>
            <v-col cols="6" sm="4" class="red">123</v-col>
            <v-col cols="6" sm="8" class="yellow">123</v-col>
          </v-row>-->
          <v-card-text>
            <!--<v-row dense>
            <v-col cols="12">-->
            <h2 align="center">FORMULARIO</h2>

            <br />
            <br />
            <!--</v-col>
            <v-col cols="12" sm="7">-->
            <v-select
              :items="selectSedrec"
              v-model="sedrec"
              item-text="no_sedrec"
              item-value="co_sedrec"
              label="SEDE"
              outlined
            ></v-select>
            <!-- </v-col>
            <v-col cols="12" sm="7">-->
            <v-select
              :items="selectTipreg"
              v-model="tipreg"
              v-validate="'required'"
              :error-messages="errors.collect('tipreg')"
              data-vv-name="tipreg"
              data-vv-as="TIPO"
              item-text="no_tipreg"
              item-value="ti_regist"
              label="TIPO*"
              outlined
            ></v-select>
            <!-- </v-col>
            <v-col cols="12" sm="6">-->
            <v-select
              :items="selectTipdoc"
              v-model="tipdoc"
              v-validate="'required'"
              :error-messages="errors.collect('tipdoc')"
              data-vv-name="tipdoc"
              data-vv-as="TIPO DE DOCUMENTO"
              item-text="no_docume"
              item-value="ti_docide"
              label="TIPO DE DOCUMENTO*"
              outlined
            ></v-select>
            <!--</v-col>
            
            <v-col cols="12" sm="6">-->
            <v-text-field
              v-model="docume"
              v-validate="'required'"
              :error-messages="errors.collect('docume')"
              data-vv-name="docume"
              data-vv-as="N° DOCUMENTO"
              label="N° DOCUMENTO*"
              outlined
            ></v-text-field>
            <!--</v-col>

            <v-col cols="12" sm="3">-->
            <v-select
              :items="selectTipper"
              v-model="person"
              v-validate="'required'"
              :error-messages="errors.collect('person')"
              data-vv-name="person"
              data-vv-as="TIPO DE PERSONA"
              item-text="no_person"
              item-value="ti_person"
              label="TIPO DE PERSONA*"
              outlined
            ></v-select>
            <!--</v-col>-->

            <template v-if="person === 1">
              <!--<v-col cols="12" sm="4">-->
              <v-text-field
                v-model="no_apepat"
                v-validate="'required'"
                :error-messages="errors.collect('no_apepat')"
                data-vv-name="no_apepat"
                data-vv-as="APELLIDO PATERNO"
                label="APELLIDO PATERNO*"
                outlined
              ></v-text-field>
              <!--</v-col>
              <v-col cols="12" sm="4">-->
              <v-text-field
                v-model="no_apemat"
                v-validate="'required'"
                :error-messages="errors.collect('no_apemat')"
                data-vv-name="no_apemat"
                data-vv-as="APELLIDO MATERNO"
                label="APELLIDO MATERNO*"
                outlined
              ></v-text-field>
              <!--</v-col>
              <v-col cols="12" sm="6">-->
              <v-text-field
                v-model="no_nombre"
                v-validate="'required'"
                :error-messages="errors.collect('no_nombre')"
                data-vv-name="no_nombre"
                data-vv-as="NOMBRES"
                label="NOMBRES*"
                outlined
              ></v-text-field>
              <!--</v-col>-->
            </template>

            <!--<v-col cols="12" sm="6">-->
            <v-text-field
              v-if="person === 2"
              v-model="no_razsoc"
              v-validate="'required'"
              :error-messages="errors.collect('no_razsoc')"
              data-vv-name="no_razsoc"
              data-vv-as="RAZÓN SOCIAL"
              label="RAZÓN SOCIAL*"
              outlined
            ></v-text-field>
            <!--</v-col>

            <v-col cols="12" sm="3">-->
            <v-checkbox
              v-if="person === 1"
              v-model="checkbox"
              label="MENOR DE EDAD"
              color="teal"
            ></v-checkbox>
            <!--</v-col>-->

            <template v-if="person === 1 && checkbox === true">
              <!--<v-col cols="12" sm="8">-->
              <v-text-field
                v-model="no_apoder"
                v-validate="'required'"
                :error-messages="errors.collect('no_apoder')"
                data-vv-name="no_apoder"
                data-vv-as="NOMBRE DE APODERADO"
                label="NOMBRE DE APODERADO*"
                outlined
              ></v-text-field>
              <!--</v-col>
              <v-col cols="12" sm="6">-->
              <v-select
                :items="selectTipdoc"
                v-model="tidoap"
                v-validate="'required'"
                :error-messages="errors.collect('tidoap')"
                data-vv-name="tidoap"
                data-vv-as="TIPO DE DOCUMENTO APODERADO"
                item-text="no_docume"
                item-value="ti_docide"
                label="TIPO DE DOCUMENTO APODERADO*"
                outlined
              ></v-select>
              <!-- </v-col>
              <v-col cols="12" sm="6">-->
              <v-text-field
                v-model="nu_docapo"
                v-validate="'required'"
                :error-messages="errors.collect('nu_docapo')"
                data-vv-name="nu_docapo"
                data-vv-as="N° DOCUMENTO APODERADO"
                label="N° DOCUMENTO APODERADO*"
                outlined
              ></v-text-field>
              <!-- </v-col>-->
            </template>

            <!--<v-col cols="12" sm="4">-->

            <v-select
              :items="selectTipvia"
              v-model="tipvia"
              item-text="no_compag"
              item-value="co_compag"
              label="TIPO DE VÍA"
              outlined
            ></v-select>
            <!--</v-col>
            <v-col cols="12" sm="4">-->
            <v-text-field
              v-model="nomvia"
              label="NOMBRE DE VÍA"
              outlined
            ></v-text-field>
            <!--</v-col>
            <v-col cols="12" sm="4">-->
            <v-text-field
              v-model="numvia"
              @keypress="isNumber"
              label="N° VÍA"
              outlined
            ></v-text-field>
            <!--</v-col>
            <v-col cols="12" sm="8">-->
            <v-text-field v-model="numman" label="MZ" outlined></v-text-field>
            <!--</v-col>
            <v-col cols="12" sm="8">-->
            <v-text-field
              v-model="numlot"
              @keypress="isNumber"
              label="N° LOTE"
              outlined
            ></v-text-field>
            <!--</v-col>-->

            <v-select
              :items="selectTipint"
              v-model="tipint"
              item-text="no_interi"
              item-value="ti_interi"
              label="INTERIOR"
              outlined
            ></v-select>
            <v-text-field
              v-model="numint"
              @keypress="isNumber"
              label="N° INTERIOR"
              outlined
            ></v-text-field>

            <v-select
              :items="selectTipzon"
              v-model="tipzon"
              item-text="no_compag"
              item-value="co_compag"
              label="TIPO DE ZONA"
              outlined
            ></v-select>
            <v-text-field
              v-model="nomzon"
              label="NOMBRE DE ZONA"
              outlined
            ></v-text-field>

            <v-select
              :items="selectDepart"
              v-model="depart"
              v-validate="'required'"
              :error-messages="errors.collect('depart')"
              data-vv-name="depart"
              data-vv-as="DEPARTAMENTO"
              item-text="no_depart"
              item-value="co_depart"
              label="DEPARTAMENTO*"
              outlined
            ></v-select>
            <v-select
              :items="selectProvin"
              v-model="provin"
              v-validate="'required'"
              :error-messages="errors.collect('provin')"
              data-vv-name="provin"
              data-vv-as="PROVINCIA"
              item-text="no_provin"
              item-value="co_provin"
              label="PROVINCIA*"
              outlined
            ></v-select>
            <v-select
              :items="selectDistri"
              v-model="distri"
              v-validate="'required'"
              :error-messages="errors.collect('distri')"
              data-vv-name="distri"
              data-vv-as="DISTRITO"
              item-text="no_distri"
              item-value="co_distri"
              label="DISTRITO*"
              outlined
            ></v-select>
            <!--:rules="celulaRule"-->
            <v-text-field
              v-model="telefo"
              @keypress="isNumber"
              label="TELÉFONO FIJO"
              outlined
            ></v-text-field>
            <v-text-field
              v-model="celula"
              @keypress="isNumber"
              label="CELULAR"
              data-vv-name="celula"
              data-vv-as="CELULAR"
              maxlength="9"
              type="tel"
              outlined
            ></v-text-field>
            <!--v-validate="'required|email|max:50|min:6'"
              :error-messages="errors.collect('corper')"
              data-vv-name="corper"
              data-vv-as="CORREO"-->

            <!--:rules="emailRules"-->
            <v-text-field
              label="CORREO ELECTRÓNICO"
              v-model="corper"
              outlined
            ></v-text-field>
            <template v-if="tipreg === 2 || tipreg === 3">
              <v-select
                :items="selectRevisi"
                v-model="revisi"
                item-text="no_revisi"
                item-value="co_revisi"
                label="REVISIÓN RECLAMO"
                outlined
              ></v-select>
            </template>
            <template>
              <v-select
                :items="selectProducto"
                v-model="productoSelect"
                item-text="no_tippro"
                item-value="co_tippro"
                label="PRODUCTO/SERVICIO"
                outlined
              ></v-select>
            </template>

            <template v-if="tipreg === 2 || tipreg === 3 || tipreg === 4">
              <v-select
                :items="selectProduc"
                v-model="produc"
                v-validate="'required'"
                :error-messages="errors.collect('produc')"
                data-vv-name="produc"
                data-vv-as="OPERACIONES/PRODUCTOS"
                item-text="no_produc"
                item-value="co_produc"
                return-object
                label="TIPO*"
                outlined
              ></v-select>
              <v-text-field
                v-if="produc.co_produc === 999"
                v-model="otrpro"
                v-validate="'required'"
                :error-messages="errors.collect('otrpro')"
                data-vv-name="otrpro"
                data-vv-as="OTRO"
                label="OTRO*"
                outlined
              ></v-text-field>
            </template>

            <template v-if="tipreg === 2 || tipreg === 3">
              <v-select
                :items="selectMotivo"
                v-model="motivo"
                v-validate="'required'"
                :error-messages="errors.collect('motivo')"
                data-vv-name="motivo"
                data-vv-as="MOTIVO"
                item-text="no_motrec"
                item-value="co_motrec"
                return-object
                label="MOTIVO*"
                outlined
              ></v-select>

              <v-text-field
                v-if="motivo.co_motrec === 999"
                v-model="otrmot"
                v-validate="'required'"
                :error-messages="errors.collect('otrmot')"
                data-vv-name="otrmot"
                data-vv-as="OTRO"
                label="OTRO*"
                outlined
              ></v-text-field>
              <v-select
                :items="selectMoneda"
                v-model="moneda"
                item-text="no_compag"
                item-value="co_compag"
                label="MONEDA"
                outlined
              ></v-select>
              <v-text-field
                v-model="montoo"
                @keypress="isNumber"
                label="MONTO"
                outlined
              ></v-text-field>
              <v-select
                :items="selectViares"
                v-model="viares"
                v-validate="'required'"
                :error-messages="errors.collect('viares')"
                data-vv-name="viares"
                data-vv-as="MEDIO DE RESPUESTA"
                item-text="no_viares"
                item-value="ti_viares"
                label="MEDIO DE RESPUESTA*"
                outlined
              ></v-select>
            </template>

            <template v-if="tipreg === 2 || tipreg === 3 || tipreg === 4">
              <v-file-input
                v-model="co_arcad1"
                label="ARCHIVO 1"
                data-vv-name="co_arcad1"
                data-vv-as="ARCHIVO 1"
                outlined
              ></v-file-input>
              <v-file-input
                v-model="co_arcad2"
                label="ARCHIVO 2"
                outlined
              ></v-file-input>
              <v-file-input
                v-model="co_arcad3"
                label="ARCHIVO 3"
                outlined
              ></v-file-input>
              <v-file-input
                v-model="co_arcad4"
                label="ARCHIVO 4"
                outlined
              ></v-file-input>
              <v-file-input
                v-model="co_arcad5"
                label="ARCHIVO 5"
                outlined
              ></v-file-input>
            </template>

            <template v-if="tipreg === 2 || tipreg === 3">
              <v-textarea
                v-model="detrec"
                v-validate="'required'"
                :error-messages="errors.collect('detrec')"
                data-vv-name="detrec"
                data-vv-as="DETALLE DEL RECLAMO"
                :rules="detalleRule"
                counter="1000"
                name="detalle"
                label="DETALLE DEL RECLAMO*"
                maxlength="1000"
                value
                hint
                outlined
              ></v-textarea>
              <v-textarea
                v-model="pedusu"
                v-validate="'required'"
                :error-messages="errors.collect('pedusu')"
                data-vv-name="pedusu"
                data-vv-as="PEDIDO DEL USUARIO"
                :rules="pedidoRule"
                counter="1000"
                name="pedido"
                label="PEDIDO DEL USUARIO*"
                maxlength="1000"
                value
                hint
                outlined
              ></v-textarea>
            </template>

            <template v-else-if="tipreg === 4">
              <v-textarea
                v-model="detped"
                v-validate="'required'"
                :error-messages="errors.collect('detped')"
                data-vv-name="detped"
                data-vv-as="DETALLE DE PEDIDO"
                :rules="consultaRule"
                counter="1000"
                name="info"
                label="DETALLE DE PEDIDO DE INFORMACIÓN Y/O CONSULTA*"
                maxlength="1000"
                value
                hint
                outlined
              ></v-textarea>
              <v-select
                :items="selectReqres"
                v-model="reqres"
                v-validate="'required'"
                :error-messages="errors.collect('reqres')"
                data-vv-name="reqres"
                data-vv-as="MEDIO DE RESPUESTA"
                item-text="no_viares"
                item-value="ti_viares"
                label="MEDIO DE RESPUESTA*"
                outlined
              ></v-select>
            </template>

            <v-snackbar
              v-model="snackbar"
              :timeout="3000"
              top
              right
              :color="color"
            >
              {{ text }}
              <v-btn color="white" text @click="snackbar = false">cerrar</v-btn>
            </v-snackbar>
            <v-checkbox
              v-model="accept_terms"
              v-validate="'required'"
              data-vv-name="accept_terms"
              data-vv-as="Términos y condiciones"
              :error-messages="errors.collect('accept_terms')"
              color="orange"
            >
              <template v-slot:label>
                <small class="terminos" style="color: rgba(0, 0, 0, 0.6)">
                  Acepto los
                  <small
                    @click="openTermsConditions()"
                    class="terminos"
                    style="color: black"
                  >
                    <b> Términos de la Política de Privacidad de Datos. </b>
                  </small>
                </small>
              </template>
            </v-checkbox>

            <b></b>
            <!--</v-row>-->
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="12" sm="6" offset-sm="3" class="text-center">
                <v-btn block color="blue" dark @click="Enviar">ENVIAR</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-dialog v-model="cargando" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Enviando...
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="modalInfo" width="450">
        <img :src="srcModal" style="width: 100%" alt="foto-modal" />
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import { isNull } from "util";
export default {
  $_veeValidate: {
    validator: "new",
  },
  data: () => ({
    modalInfo: false,
    srcModal: require("@/assets/cominicado-INDECOPI.png"),
    sedrec: null,
    accept_terms: null,
    selectSedrec: [],
    tipreg: null,
    selectTipreg: [],
    person: null,
    selectTipper: [],
    tipdoc: null,
    selectTipdoc: [],
    docume: "",
    no_apepat: "",
    no_apemat: "",
    no_nombre: "",
    no_apenom: "",
    no_razsoc: "",
    co_credit: "",
    tipvia: null,
    selectTipvia: [],
    nomvia: "",
    numvia: "",
    numman: "",
    numlot: "",
    tipint: null,
    selectTipint: [],
    numint: "",
    tipzon: null,
    selectTipzon: [],
    nomzon: "",
    depart: null,
    selectDepart: [],
    provin: null,
    selectProvin: [],
    distri: null,
    selectDistri: [],
    co_ubigeo: "",
    telefo: "",
    celula: null,
    corper: "",
    revisi: 1,
    productoSelect: 2,
    selectRevisi: [],
    produc: {
      co_produc: null,
    },
    selectProduc: [],
    otrpro: "",
    motivo: {
      co_motrec: null,
    },
    selectMotivo: [],
    otrmot: "",
    moneda: null,
    selectMoneda: [],
    montoo: null,
    viares: null,
    selectViares: [],
    selectProducto: [],
    co_arcad1: null,
    co_arcad2: null,
    co_arcad3: null,
    co_arcad4: null,
    co_arcad5: null,
    detrec: "",
    pedusu: "",
    detped: "",
    reqres: null,
    selectReqres: [],
    snackbar: false,
    text: "",
    color: "orange",
    checkbox: false,
    cargando: false,
    no_apoder: "",
    tidoap: null,
    nu_docapo: "",
    /*
    emailRules: [
      v =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail inválido"
    ],
    */
    /*
    celulaRule: [
      v => v.length === 9 || "Debe contener 9 dígitos"
    ],
*/
    detalleRule: [
      (v) => v.length <= 1000 || "Debe contener un máximo de 1000 caracteres",
    ],

    pedidoRule: [
      (v) => v.length <= 1000 || "Debe contener un máximo de 1000 caracteres",
    ],

    consultaRule: [
      (v) => v.length <= 1000 || "Debe contener un máximo de 1000 caracteres",
    ],
  }),
  methods: {
    openTermsConditions() {
      console.log("estamos en el loggg");
      window.open(
        `https://acceso.com.pe/wp-content/uploads/2023/09/POLITICA-DE-PRIVACIDAD-RECLAMOS-Y-QUEJAS-ACCESO-CREDITICIO-S.A..pdf`,
        "Diseño Web",
        "width=600, height=500"
      );
    },

    limpiarcampos() {
      this.celula = this.celula;
    },
    descargar(arcadj) {
      console.log(
        `https://workflow.pe/apiacr/file?co_arcadj=${arcadj}`
        //`https://sd1.accesocrediticio.com/apiacr/file?co_arcadj=${arcadj}`
      );
      //console.log("Abriendo navegador");

      window.open(
        `https://workflow.pe/apiacr/file?co_arcadj=${arcadj}`,
        "Diseño Web",
        "width=600, height=500"
      );
      //window.open(`https://sd1.accesocrediticio.com/apiacr/file?co_arcadj=${arcadj}`, "Diseño Web", "width=600, height=500")
    },
    isNumber(evt) {
      evt = evt || window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async getArchivo(file) {
      console.log("here");
      const formData = new FormData();
      formData.append("file", file);
      const responseUpload = await axios.post(
        `https://api.acceso.com.pe/uploadfileJS/v1.0/uploadfile`,
        formData,
        {
          headers: {
            "content-type":
              "multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW",
            Authorization: "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
            "x-request-id": "123123123123123",
          },
        }
      );
      console.log(responseUpload.data);
      return responseUpload.data.codigoArchivo;
    },

    async Enviar() {
      console.log(this.produc);
      console.log(this.produc.co_prosbs);
      let co_correo = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
        this.corper
      );
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          /*if (this.sedrec === null) {
        alert("Por favor seleccione la Sede.");
      } else*/

          try {
            this.color = "orange";
            //throw new Error("tara")
            if (this.tipreg === null) {
              this.text = "Por favor seleccione el Tipo de Registro.";
              this.snackbar = true;
            } else if (this.tipdoc === null) {
              this.text = "Por favor seleccione el Tipo de Documento.";
              this.snackbar = true;
            } else if (this.docume.trim() === "") {
              this.text = "Por favor ingrese el N° Documento.";
              this.snackbar = true;
            } else if (
              (this.tipdoc === "D" && this.docume.length !== 8) ||
              (this.tipdoc === "E" && this.docume.length !== 12) ||
              (this.tipdoc === "T" && this.docume.length !== 12) ||
              (this.tipdoc === "R" && this.docume.length !== 11) ||
              (this.tipdoc === "P" && this.docume.length !== 9)
            ) {
              this.text = "Ingrese correctamente el N° de Documento";
              this.snackbar = true;
            } else if (this.person === null) {
              this.text = "Por favor seleccione el Tipo de Persona.";
              this.snackbar = true;
            } else if (this.person === 1 && this.no_apepat.trim() === "") {
              this.text = "Por favor ingrese el Apellido Paterno.";
              this.snackbar = true;
            } else if (this.person === 1 && this.no_apemat.trim() === "") {
              this.text = "Por favor ingrese el Apellido Materno.";
              this.snackbar = true;
            } else if (this.person === 1 && this.no_nombre.trim() === "") {
              this.text = "Por favor ingrese el Nombre.";
              this.snackbar = true;
            } else if (this.person === 2 && this.no_razsoc.trim() === "") {
              this.text = "Por favor ingrese la Razón Social.";
              this.snackbar = true;
            } else if (this.checkbox === true && this.no_apoder.trim() === "") {
              this.text = "Por favor ingrese el Nombre del Apoderado.";
              this.snackbar = true;
            } else if (this.checkbox === true && this.tidoap === null) {
              this.text =
                "Por favor seleccione el Tipo de Documento Apoderado.";
              this.snackbar = true;
            } else if (this.checkbox === true && this.nu_docapo.trim() === "") {
              this.text = "Por favor ingrese el N° Documento Apoderado.";
              this.snackbar = true;
            } else if (
              (this.checkbox === true &&
                this.tidoap === "D" &&
                this.nu_docapo.length !== 8) ||
              (this.checkbox === true &&
                this.tidoap === "E" &&
                this.nu_docapo.length !== 12) ||
              (this.checkbox === true &&
                this.tidoap === "T" &&
                this.nu_docapo.length !== 12) ||
              (this.checkbox === true &&
                this.tidoap === "R" &&
                this.nu_docapo.length !== 11) ||
              (this.checkbox === true &&
                this.tidoap === "P" &&
                this.nu_docapo.length !== 9)
            ) {
              this.text = "Ingrese correctamente el N° Documento del Apoderado";
              this.snackbar = true;
            } else if (this.depart === null) {
              this.text = "Por favor seleccione el Departamento.";
              this.snackbar = true;
            } else if (this.provin === null) {
              this.text = "Por favor seleccione la Provincia.";
              this.snackbar = true;
            } else if (this.distri === null) {
              this.text = "Por favor seleccione el Distrito.";
              this.snackbar = true;
            } else if (
              (this.tipreg === 2 || this.tipreg === 3) &&
              this.produc.co_produc === null
            ) {
              this.text = "Por favor seleccione el Producto.";
              this.snackbar = true;
            } else if (
              (this.tipreg === 2 || this.tipreg === 3) &&
              this.produc.co_produc === 999 &&
              this.otrpro.trim() === ""
            ) {
              this.text = "Por favor ingrese la descripción de Otro Producto.";
              this.snackbar = true;
            } else if (
              (this.tipreg === 2 || this.tipreg === 3) &&
              this.motivo.co_motrec === null
            ) {
              this.text = "Por favor seleccione el Motivo.";
              this.snackbar = true;
            } else if (
              (this.tipreg === 2 || this.tipreg === 3) &&
              this.motivo.co_motrec === 999 &&
              this.otrmot.trim() === ""
            ) {
              this.text = "Por favor ingrese la descripción de Otro Motivo.";
              this.snackbar = true;
            } else if (
              (this.tipreg === 2 || this.tipreg === 3) &&
              this.moneda === null &&
              this.montoo !== null
            ) {
              this.text = "Por favor seleccione el Tipo de Moneda.";
              this.snackbar = true;
            } else if (
              (this.tipreg === 2 || this.tipreg === 3) &&
              this.moneda !== null &&
              (this.montoo === null || this.montoo.trim() === "")
            ) {
              this.text = "Por favor ingrese el Monto.";
              this.snackbar = true;
            } else if (
              (this.tipreg === 2 || this.tipreg === 3) &&
              this.viares === null
            ) {
              this.text = "Por favor seleccione el Medio de Respuesta.";
              this.snackbar = true;
              /*} else if (
          this.tipreg === 2 &&
          this.viares === 1 &&
          this.tipvia === null
        ) {
          this.text = "Por favor seleccione el Tipo de Vía.";
          this.snackbar = true;
        } else if (
          this.tipreg === 2 &&
          this.viares === 1 &&
          this.nomvia.trim() === ""
        ) {
          this.text = "Por favor ingrese el Nombre de Vía.";
          this.snackbar = true;
        } else if (
          this.tipreg === 2 &&
          this.viares === 1 &&
          this.tipint === null
        ) {
          this.text = "Por favor seleccione el Interior.";
          this.snackbar = true;
        } else if (
          this.tipreg === 2 &&
          this.viares === 1 &&
          this.tipzon === null
        ) {
          this.text = "Por favor seleccione el Tipo de Zona.";
          this.snackbar = true;
        } else if (
          this.tipreg === 2 &&
          this.viares === 1 &&
          this.nomzon.trim() === ""
        ) {
          this.text = "Por favor ingrese el Nombre de la Zona.";
          this.snackbar = true;*/
            } else if (
              (this.tipreg === 2 || this.tipreg === 3) &&
              this.viares === 2 &&
              this.corper.trim() === ""
            ) {
              this.text = "Por favor ingrese el Correo Electrónico.";
              this.snackbar = true;
            } else if (
              (this.tipreg === 2 || this.tipreg === 3) &&
              this.viares === 2 &&
              co_correo === false
            ) {
              this.text = "Ingrese correctamente el Correo Electrónico.";
              this.snackbar = true;
            } else if (
              (this.tipreg === 2 || this.tipreg === 3) &&
              this.detrec.trim() === ""
            ) {
              this.text = "Por favor ingrese el Detalle del Reclamo.";
              this.snackbar = true;
            } else if (
              (this.tipreg === 2 || this.tipreg === 3) &&
              this.detrec.length > 1000
            ) {
              this.text =
                "La cantidad de carcacteres del Detalle excede los 1000.";
              this.snackbar = true;
            } else if (
              (this.tipreg === 2 || this.tipreg === 3) &&
              this.pedusu.trim() === ""
            ) {
              this.text = "Por favor ingrese el Pedido al Usuario.";
              this.snackbar = true;
            } else if (
              (this.tipreg === 2 || this.tipreg === 3) &&
              !this.accept_terms
            ) {
              this.text = "Por favor acepte los términos y condiciones.";
              this.snackbar = true;
            } else if (
              (this.tipreg === 2 || this.tipreg === 3) &&
              this.pedusu.length > 1000
            ) {
              this.text =
                "La cantidad de carcacteres del Pedido excede los 1000.";
              this.snackbar = true;
            } else if (this.tipreg === 4 && this.detped.trim() === "") {
              this.text = "Por favor ingrese el Detalle del Pedido.";
              this.snackbar = true;
            } else if (this.tipreg === 4 && this.reqres === null) {
              this.text = "Por favor seleccione el Medio de Respuesta.";
              this.snackbar = true;
              /*
            } else if (
              this.tipreg === 4 &&
              this.reqres === 1 &&
              this.tipvia === null
            ) {
              this.text = "Por favor seleccione el Tipo de Vía.";
              this.snackbar = true;
            } else if (
              this.tipreg === 4 &&
              this.reqres === 1 &&
              this.nomvia.trim() === ""
            ) {
              this.text = "Por favor ingrese el Nombre de Vía.";
              this.snackbar = true;
            } else if (
              this.tipreg === 4 &&
              this.reqres === 1 &&
              this.tipint === null
            ) {
              this.text = "Por favor seleccione el Interior.";
              this.snackbar = true;
            } else if (
              this.tipreg === 4 &&
              this.reqres === 1 &&
              this.tipzon === null
            ) {
              this.text = "Por favor seleccione el Tipo de Zona.";
              this.snackbar = true;
            } else if (
              this.tipreg === 4 &&
              this.reqres === 1 &&
              this.nomzon.trim() === ""
            ) {
              this.text = "Por favor ingrese el Nombre de la Zona.";
              this.snackbar = true;
            */
            } else if (
              this.tipreg === 4 &&
              this.reqres === 2 &&
              this.corper.trim() === ""
            ) {
              this.text = "Por favor ingrese el Correo Electrónico.";
              this.snackbar = true;
            } else {
              console.log("here");
              this.cargando = true;
              this.color = "green";
              const co_arcad1 =
                this.co_arcad1 === null
                  ? null
                  : await this.getArchivo(this.co_arcad1);
              const co_arcad2 =
                this.co_arcad2 === null
                  ? null
                  : await this.getArchivo(this.co_arcad2);
              const co_arcad3 =
                this.co_arcad3 === null
                  ? null
                  : await this.getArchivo(this.co_arcad3);
              const co_arcad4 =
                this.co_arcad4 === null
                  ? null
                  : await this.getArchivo(this.co_arcad4);
              const co_arcad5 =
                this.co_arcad5 === null
                  ? null
                  : await this.getArchivo(this.co_arcad5);

              var no_client =
                this.person === 1
                  ? this.no_apepat + " " + this.no_apemat + " " + this.no_nombre
                  : this.no_razsoc;

              let sh_camino = "";
              if (this.tipvia === 1) {
                sh_camino = "AV.";
              } else if (this.tipvia === 2) {
                sh_camino = "JR.";
              } else if (this.tipvia === 3) {
                sh_camino = "CA.";
              } else if (this.tipvia === 4) {
                sh_camino = "PS.";
              } else if (this.tipvia === 99) {
                sh_camino = "MZ.";
              }

              let sh_interi = "";
              if (this.tipint === 1) {
                sh_interi = "DPTO.";
              } else if (this.tipint === 2) {
                sh_interi = "QTA.";
              } else if (this.tipint === 3) {
                sh_interi = "PISO";
              }

              let sh_zongeo = "";
              if (this.tipzon === 1) {
                sh_zongeo = "URB.";
              } else if (this.tipzon === 2) {
                sh_zongeo = "PJ.";
              } else if (this.tipzon === 3) {
                sh_zongeo = "AA.HH.";
              } else if (this.tipzon === 99) {
                sh_zongeo = "RED.";
              }

              var mz_regist = this.numman.trim() === "" ? "" : "Mz.";
              var lt_regist = this.numlot.trim() === "" ? "" : "Lt.";

              const co_direcc =
                (this.tipvia === null ? "" : sh_camino) +
                " " +
                (this.nomvia === null ? "" : this.nomvia) +
                " " +
                (this.numvia === null ? "" : this.numvia) +
                " " +
                mz_regist +
                " " +
                (this.numman === null ? "" : this.numman) +
                " " +
                lt_regist +
                " " +
                (this.numlot === null ? "" : this.numlot) +
                " " +
                (this.tipint === null ? "" : sh_interi) +
                " " +
                (this.numint === null ? "" : this.numint) +
                " " +
                (this.tipzon === null ? "" : sh_zongeo) +
                " " +
                (this.nomzon === null ? "" : this.nomzon);

              const data = {
                p_co_tipvia: this.tipvia === null ? "" : sh_camino,
                p_no_tipvia: this.nomvia === null ? "" : this.nomvia,
                p_nu_tipvia: this.numvia === null ? "" : this.numvia,
                p_nu_manzan: this.numman === null ? "" : this.numman,
                p_nu_lotiza: this.numlot === null ? "" : this.numlot,
                p_co_tipint: this.tipint === null ? "" : sh_interi,
                p_nu_tipint: this.numint === null ? "" : this.numint,
                p_co_tipzon: this.tipzon === null ? "" : sh_zongeo,
                p_no_tipzon: this.nomzon === null ? "" : this.nomzon,
                p_us_regist: null,
                p_co_sedrec: this.sedrec,
                p_ti_regist: this.tipreg,
                p_ti_person: this.person,
                p_co_credit: this.no_apenom === null ? "" : this.co_credit,
                p_no_client: no_client,
                p_ti_docide: this.tipdoc,
                p_nu_docide: this.docume,
                p_no_apoder: this.no_apoder,
                p_ti_docapo: this.tidoap === null ? "" : this.tidoap,
                p_nu_docapo: this.nu_docapo,
                p_co_direcc: co_direcc,
                p_co_ubigeo: this.distri,
                p_nu_telefo: this.telefo === null ? "" : this.telefo,
                p_nu_celula: this.celula === null ? "" : this.celula,
                p_co_correo: this.corper === null ? "" : this.corper,
                p_co_medrec: 4,
                p_co_proser: this.produc.co_produc,
                p_de_otprod: this.otrpro,
                p_co_motrec: this.motivo.co_motrec,
                p_de_otmoti: this.otrmot,
                p_ti_moneda: this.moneda === null ? "" : this.moneda,
                p_ca_monrec: this.montoo,
                p_ti_viares: this.viares,
                p_co_arcad1: co_arcad1,
                p_co_arcad2: co_arcad2,
                p_co_arcad3: co_arcad3,
                p_co_arcad4: co_arcad4,
                p_co_arcad5: co_arcad5,
                p_de_detrec: this.detrec,
                p_de_pedusu: this.pedusu,
                p_co_prosbs: this.produc.co_prosbs,
                p_co_motsbs: this.motivo.co_motsbs,
                p_co_cansbs: "03",
                p_co_revisi: this.revisi,
                p_co_tippro: this.productoSelect,
                tipo: 1,
              };

              console.log("data_1", data);

              if (this.tipreg === 2 || this.tipreg === 3) {
                const response_insert = await axios.post(
                  `${process.env.VUE_APP_URL_BASE}/acceso/v2.0/simulacion/reclamos/getInsert`,
                  data,
                  {
                    headers: {
                      "content-type": "application/json",
                      Authorization:
                        "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
                    },
                  }
                );
                //console.log("funcion", response_insert.data[0].pbinsertreclam);
                var co_reclam = response_insert.data[0].pbinsertreclam_v2;

                console.log("<-------- INICIO ------------------>");
                console.log("EN LA CREACION DEL ARCDJ");
                const bodyJson = {
                  co_reclam: co_reclam,
                  p_ti_regist: this.tipreg,
                };
                console.log("bodyJson", bodyJson);
                const getDataJso = await axios.post(
                  `${process.env.VUE_APP_URL_BASE}/acceso/v2.0/simulacion/reclamos/getDataJso`,
                  bodyJson,
                  {
                    headers: {
                      "content-type": "application/json",
                      Authorization:
                        "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
                    },
                  }
                );
                console.log("getDataJsogetDataJso", getDataJso);
                console.log("getDataJso[0].va_datrec --->", getDataJso.data);
                const arcdjNew = await axios.post(
                  `${process.env.VUE_APP_URL_BASE}/reporte/generic/3`,
                  getDataJso.data,
                  {
                    headers: {
                      "content-type": "application/json",
                      Authorization:
                        "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
                    },
                  }
                );
                console.log("arcdjNewarcdjNew", arcdjNew);
                console.log("arcdjNewarcdjNew", arcdjNew.data.co_archiv);
                let arc_archivo = arcdjNew.data.co_archiv;
                console.log(
                  `https://workflow.pe/apiacr/file?co_arcadj=${arc_archivo}&idf=y`
                );
                var condicion = this.tipreg == 2 ? "Reclamo" : "Queja";
                var mensaje =
                  "Sr(a) " +
                  no_client +
                  " se ha registrado su " +
                  condicion +
                  " correctamente, " +
                  "en el transcurso de los días le estaremos dando respuesta al mismo.";

                //Generar co_arcadj para la solicitud de cada cliente
                console.log("mensaje", mensaje);
                const data_2 = {
                  tipo: 2,
                  p_co_reclam: co_reclam,
                  p_co_arcadj: arc_archivo,
                  p_ti_regist: this.tipreg,
                };

                console.log("data_2", data_2);

                const response_update = await axios.post(
                  `${process.env.VUE_APP_URL_BASE}/acceso/v2.0/simulacion/reclamos/getInsert`,
                  data_2,
                  {
                    headers: {
                      "content-type": "application/json",
                      Authorization:
                        "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
                    },
                  }
                );
                console.log("response_update", response_update);
                if (this.corper.trim() !== "") {
                  var mensajeCorreo = `{
                  "de": "Acceso Corp <workflow@acceso.com.pe>",
                  "para": "${this.corper}",
                  "asunto": "${condicion}",
                  "mensaje": "${mensaje}",
                  "adjuntos": [
                    {
                      "filename": "${condicion}.pdf",
                      "path": "https://workflow.pe/apiacr/file?co_arcadj=${arc_archivo}&idf=y"
                    }
                  ]
                }`;
                  console.log("mensajeCorreo", mensajeCorreo);
                  const resemail = await axios.post(
                    `https://api.acceso.com.pe/private/v1.0/correosAdjuntos`,
                    mensajeCorreo,
                    {
                      headers: {
                        "content-type": "application/json",
                        Authorization:
                          "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
                      },
                    }
                  );

                  console.log(resemail.data);
                }

                var mensajeCorreo = `{
              "de": "Acceso Corp <workflow@acceso.com.pe>",
              "para": "reclamos@acceso.com.pe",
              "asunto": "${condicion}",
              "mensaje": "${mensaje}",
              "adjuntos": [
                {
                  "filename": "${condicion}.pdf",
                  "path": "https://workflow.pe/apiacr/file?co_arcadj=${arc_archivo}&idf=y"
                }
              ]
            }`;

                const resemail = await axios.post(
                  `https://api.acceso.com.pe/private/v1.0/correosAdjuntos`,
                  mensajeCorreo,
                  {
                    headers: {
                      "content-type": "application/json",
                      Authorization:
                        "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
                    },
                  }
                );

                this.color = "green";
                this.text = condicion + " REGISTRADO.";
                this.snackbar = true;
                this.descargar(arc_archivo);
              } else if (this.tipreg === 4) {
                const response_insert2 = await axios.post(
                  `${process.env.VUE_APP_URL_BASE}/acceso/v2.0/simulacion/reclamos/getInsert2`,
                  {
                    p_co_tipvia: this.tipvia === null ? "" : sh_camino,
                    p_no_tipvia: this.nomvia === null ? "" : this.nomvia,
                    p_nu_tipvia: this.numvia === null ? "" : this.numvia,
                    p_nu_manzan: this.numman === null ? "" : this.numman,
                    p_nu_lotiza: this.numlot === null ? "" : this.numlot,
                    p_co_tipint: this.tipint === null ? "" : sh_interi,
                    p_nu_tipint: this.numint === null ? "" : this.numint,
                    p_co_tipzon: this.tipzon === null ? "" : sh_zongeo,
                    p_no_tipzon: this.nomzon === null ? "" : this.nomzon,
                    p_us_regist: null,
                    p_co_sedrec: this.sedrec,
                    p_ti_regist: this.tipreg,
                    p_ti_person: this.person,
                    p_co_credit: this.no_apenom === null ? "" : this.co_credit,
                    p_no_client: no_client,
                    p_ti_docide: this.tipdoc,
                    p_nu_docide: this.docume,
                    p_co_direcc: co_direcc,
                    p_co_ubigeo: this.distri,
                    p_nu_telefo: this.telefo,
                    p_nu_celula: this.celula,
                    p_co_correo: this.corper,
                    p_co_medrec: 4,
                    p_co_proser: null,
                    p_de_otprod: "",
                    p_co_motrec: null,
                    p_de_otmoti: "",
                    p_ti_viares: this.reqres,
                    p_co_arcad1: co_arcad1,
                    p_co_arcad2: co_arcad2,
                    p_co_arcad3: co_arcad3,
                    p_co_arcad4: co_arcad4,
                    p_co_arcad5: co_arcad5,
                    p_de_detrec: this.detped /*""*/,
                    p_de_pedusu: "",
                    p_de_solici: this.detped,
                    tipo: 1,
                  },
                  {
                    headers: {
                      "content-type": "application/json",
                      Authorization:
                        "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
                    },
                  }
                );

                var co_reclam = response_insert2.data[0].pbinsertrequer;

                console.log("<-------- INICIO ------------------>");
                console.log("EN LA CREACION DEL ARCDJ");
                const bodyJson = {
                  co_reclam: co_reclam,
                };
                const getDataJso = await axios.post(
                  `${process.env.VUE_APP_URL_BASE}/acceso/v2.0/simulacion/reclamos/getDataJso`,
                  bodyJson,
                  {
                    headers: {
                      "content-type": "application/json",
                      Authorization:
                        "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
                    },
                  }
                );
                console.log("getDataJsogetDataJso", getDataJso);
                console.log("getDataJso[0].va_datrec --->", getDataJso.data);
                const arcdjNew = await axios.post(
                  `${process.env.VUE_APP_URL_BASE}/reporte/generic/3`,
                  getDataJso.data,
                  {
                    headers: {
                      "content-type": "application/json",
                      Authorization:
                        "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
                    },
                  }
                );
                console.log("arcdjNewarcdjNew", arcdjNew);
                console.log("arcdjNewarcdjNew", arcdjNew.data.co_archiv);
                let arc_archivo = arcdjNew.data.co_archiv;
                console.log(
                  `https://workflow.pe/apiacr/file?co_arcadj=${arc_archivo}&idf=y&idf=y`
                );
                var mensaje =
                  "Sr(a) " +
                  no_client +
                  " se ha registrado su requerimiento correctamente, " +
                  "en el transcurso de los días le estaremos dando respuesta al mismo.";

                console.log("mensajemensajemensaje", mensaje);
                const data_req = {
                  tipo: 2,
                  p_co_reclam: co_reclam,
                  p_co_arcadj: arc_archivo,
                };

                console.log("data_reqdata_reqdata_req", data_req);

                const response_update = await axios.post(
                  `${process.env.VUE_APP_URL_BASE}/acceso/v2.0/simulacion/reclamos/getInsert2`,
                  data_req,
                  {
                    headers: {
                      "content-type": "application/json",
                      Authorization:
                        "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
                    },
                  }
                );
                console.log("response_updateresponse_update", response_update);
                if (this.corper.trim() !== "") {
                  var mensajeCorreo = `{
                    "de": "Acceso Corp <workflow@acceso.com.pe>",
                    "para": "${this.corper}",
                    "asunto": "REQUERIMIENTO",
                    "mensaje": "${mensaje}",
                    "adjuntos": [
                      {
                        "filename": "Requerimiento.pdf",
                        "path": "https://workflow.pe/apiacr/file?co_arcadj=${arc_archivo}&idf=y"
                      }
                    ]
                  }`;

                  const resemail = await axios.post(
                    `https://api.acceso.com.pe/private/v1.0/correosAdjuntos`,
                    mensajeCorreo,
                    {
                      headers: {
                        "content-type": "application/json",
                        Authorization:
                          "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
                      },
                    }
                  );

                  //console.log(resemail.data);
                }

                var mensajeCorreo = `{
                    "de": "Acceso Corp <workflow@acceso.com.pe>",
                    "para": "reclamos@acceso.com.pe",
                    "asunto": "REQUERIMIENTO",
                    "mensaje": "${mensaje}",
                    "adjuntos": [
                      {
                        "filename": "Requerimiento.pdf",
                        "path": "https://workflow.pe/apiacr/file?co_arcadj=${arc_archivo}&idf=y"
                      }
                    ]
                  }`;

                const resemail = await axios.post(
                  `https://api.acceso.com.pe/private/v1.0/correosAdjuntos`,
                  mensajeCorreo,
                  {
                    headers: {
                      "content-type": "application/json",
                      Authorization:
                        "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
                    },
                  }
                );

                this.color = "green";
                this.text = "REQUERIMIENTO REGISTRADO.";
                this.snackbar = true;

                this.descargar(arc_archivo);
              }

              this.cargando = false;

              this.sedrec = null;
              this.tipreg = null;
              this.tipdoc = null;
              this.docume = "";
              this.person = null;
              this.no_apepat = "";
              this.no_apemat = "";
              this.no_nombre = "";
              this.no_razsoc = "";
              this.no_apoder = "";
              this.tidoap = null;
              this.nu_docapo = "";
              this.tipvia = null;
              this.nomvia = "";
              this.numvia = "";
              this.numman = "";
              this.numlot = "";
              this.tipint = null;
              this.numint = "";
              this.tipzon = null;
              this.nomzon = "";
              this.depart = null;
              this.provin = null;
              this.distri = null;
              this.telefo = "";
              this.celula = null;
              this.corper = "";
              this.revisi = 1;
              this.productoSelect = 2;
              this.produc = { co_produc: null };
              this.otrpro = "";
              this.motivo = { co_motrec: null };
              this.otrmot = "";
              this.moneda = null;
              this.montoo = null;
              this.viares = null;
              this.co_arcad1 = null;
              this.co_arcad2 = null;
              this.co_arcad3 = null;
              this.co_arcad4 = null;
              this.co_arcad5 = null;
              this.detrec = "";
              this.pedusu = "";
              this.detped = "";
              this.reqres = null;
              this.checkbox = false;
            }
          } catch (error) {
            this.color = "red";
            this.text = "Ha ocurrido un error interno";
            this.snackbar = true;
          }

          /* cuando todo esta ok */
        } else {
          this.color = "orange";
          this.text = "Faltan datos por completar";
          this.snackbar = true;
          /* falta algun dato */
        }
      });
    },
  },
  watch: {
    async docume(nuevo) {
      console.log("valor : ", nuevo);

      var response;

      if (
        (this.tipdoc === "D" && nuevo.length === 8) ||
        (this.tipdoc === "E" && nuevo.length === 12) ||
        (this.tipdoc === "T" && nuevo.length === 12) ||
        (this.tipdoc === "R" && nuevo.length === 11) ||
        (this.tipdoc === "P" && nuevo.length === 9) ||
        this.tipdoc === "I"
      ) {
        response = await axios.post(
          `${process.env.VUE_APP_URL_BASE}/acceso/v2.0/simulacion/reclamos/getDatcli`,
          { nu_docide: nuevo },
          {
            headers: {
              "content-type": "application/json",
              Authorization: "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
            },
          }
        );

        console.log(response.data[0]);
        this.person = response.data[0].ti_person;
        //this.tipper = response.data[0].no_person;
        this.no_apepat = response.data[0].no_apepat;
        this.no_apepat = this.no_apepat === null ? "" : this.no_apepat;
        this.no_apemat = response.data[0].no_apemat;
        this.no_apemat = this.no_apemat === null ? "" : this.no_apemat;
        this.no_nombre = response.data[0].no_nombre;
        this.no_nombre = this.no_nombre === null ? "" : this.no_nombre;
        this.no_apenom = response.data[0].no_apenom;
        this.tipvia = response.data[0].ti_camino;
        this.nomvia = response.data[0].no_camino;
        this.nomvia = this.nomvia === null ? "" : this.nomvia;
        this.numvia = response.data[0].nu_camino;
        this.numvia = this.numvia === null ? "" : this.numvia;
        this.numman = response.data[0].nu_manzan;
        this.numman = this.numman === null ? "" : this.numman;
        this.numlot = response.data[0].nu_lotiza;
        this.numlot = this.numlot === null ? "" : this.numlot;
        this.tipint = response.data[0].ti_interi;
        this.numint = response.data[0].nu_interi;
        this.numint = this.numint === null ? "" : this.numint;
        this.tipzon = response.data[0].ti_zongeo;
        this.nomzon = response.data[0].no_zongeo;
        this.nomzon = this.nomzon === null ? "" : this.nomzon;
        this.telefo = response.data[0].nu_telfij;
        this.telefo = this.telefo === null ? "" : this.telefo;
        this.celula = response.data[0].nu_telcel;
        this.celula = this.celula === null ? "" : this.celula;
        this.corper = response.data[0].co_corper;
        this.corper = this.corper === null ? "" : this.corper;
        this.co_credit = response.data[0].co_contra;
        this.co_credit = this.co_credit === null ? "" : this.co_credit;
        //this.produc = response.data[0].co_procli;
        this.co_ubigeo = response.data[0].co_ubigeo;
        if (this.co_ubigeo === null) {
          this.depart = null;
          this.provin = null;
          this.distri = null;
        } else {
          this.depart = this.co_ubigeo.slice(0, 2);
          this.provin = this.co_ubigeo.slice(0, 4);
          this.distri = this.co_ubigeo;
        }
      }
      //console.log(co_ubigeo, this.depart, this.provin, this.distri);
    },
    async depart(nuevo) {
      //console.log("valor : ", nuevo);
      const response_provin = await axios.post(
        `${process.env.VUE_APP_URL_BASE}/acceso/v2.0/simulacion/reclamos/getProvin`,
        { co_depart: nuevo },
        {
          headers: {
            "content-type": "application/json",
            Authorization: "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
          },
        }
      );
      this.selectProvin = response_provin.data;
    },
    async provin(nuevo) {
      //console.log("valor : ", nuevo);
      const response_distri = await axios.post(
        `${process.env.VUE_APP_URL_BASE}/acceso/v2.0/simulacion/reclamos/getDistri`,
        { co_provin: nuevo },
        {
          headers: {
            "content-type": "application/json",
            Authorization: "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
          },
        }
      );
      this.selectDistri = response_distri.data;
    },
  },
  async created() {
    console.log("created");

    const response_sedrec = await axios.post(
      // url: `${process.env.VUE_APP_URL}/evaluacion/v1.0/landing`,

      `${process.env.VUE_APP_URL_BASE}/acceso/v2.0/simulacion/reclamos/getSedrec`,
      {},
      {
        headers: {
          "content-type": "application/json",
          Authorization: "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
        },
      }
    );
    this.selectSedrec = response_sedrec.data;

    const response_tipreg = await axios.post(
      `${process.env.VUE_APP_URL_BASE}/acceso/v2.0/simulacion/reclamos/getTipreg`,
      {},
      {
        headers: {
          "content-type": "application/json",
          Authorization: "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
        },
      }
    );
    this.selectTipreg = response_tipreg.data;

    const response_selectTipreg = await axios.post(
      `${process.env.VUE_APP_URL_BASE}/acceso/v2.0/simulacion/reclamos/getTypeProduct`,
      {},
      {
        headers: {
          "content-type": "application/json",
          Authorization: "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
        },
      }
    );
    this.selectProducto = response_selectTipreg.data;

    const response_medrec = await axios.post(
      `${process.env.VUE_APP_URL_BASE}/acceso/v2.0/simulacion/reclamos/getMedrec`,
      {},
      {
        headers: {
          "content-type": "application/json",
          Authorization: "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
        },
      }
    );
    this.selectMedrec = response_medrec.data;

    const response_tipper = await axios.post(
      `${process.env.VUE_APP_URL_BASE}/acceso/v2.0/simulacion/reclamos/getTipper`,
      {},
      {
        headers: {
          "content-type": "application/json",
          Authorization: "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
        },
      }
    );
    this.selectTipper = response_tipper.data;

    const response_tipdoc = await axios.post(
      `${process.env.VUE_APP_URL_BASE}/acceso/v2.0/simulacion/reclamos/getTipdoc`,
      {},
      {
        headers: {
          "content-type": "application/json",
          Authorization: "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
        },
      }
    );
    this.selectTipdoc = response_tipdoc.data;

    const response_tipvia = await axios.post(
      `${process.env.VUE_APP_URL_BASE}/acceso/v2.0/simulacion/reclamos/getTipvia`,
      {},
      {
        headers: {
          "content-type": "application/json",
          Authorization: "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
        },
      }
    );
    this.selectTipvia = response_tipvia.data;

    const response_tipint = await axios.post(
      `${process.env.VUE_APP_URL_BASE}/acceso/v2.0/simulacion/reclamos/getTipint`,
      {},
      {
        headers: {
          "content-type": "application/json",
          Authorization: "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
        },
      }
    );
    this.selectTipint = response_tipint.data;

    const response_tipzon = await axios.post(
      `${process.env.VUE_APP_URL_BASE}/acceso/v2.0/simulacion/reclamos/getTipzon`,
      {},
      {
        headers: {
          "content-type": "application/json",
          Authorization: "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
        },
      }
    );
    this.selectTipzon = response_tipzon.data;

    const response_depart = await axios.post(
      `${process.env.VUE_APP_URL_BASE}/acceso/v2.0/simulacion/reclamos/getDepart`,
      {},
      {
        headers: {
          "content-type": "application/json",
          Authorization: "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
        },
      }
    );
    this.selectDepart = response_depart.data;

    const response_revisi = await axios.post(
      `${process.env.VUE_APP_URL_BASE}/acceso/v2.0/simulacion/reclamos/getRevisi`,
      {},
      {
        headers: {
          "content-type": "application/json",
          Authorization: "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
        },
      }
    );
    this.selectRevisi = response_revisi.data;

    const response_produc = await axios.post(
      `${process.env.VUE_APP_URL_BASE}/acceso/v2.0/simulacion/reclamos/getProduc`,
      {},
      {
        headers: {
          "content-type": "application/json",
          Authorization: "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
        },
      }
    );
    this.selectProduc = response_produc.data;

    const response_motivo = await axios.post(
      `${process.env.VUE_APP_URL_BASE}/acceso/v2.0/simulacion/reclamos/getMotivo`,
      {},
      {
        headers: {
          "content-type": "application/json",
          Authorization: "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
        },
      }
    );
    this.selectMotivo = response_motivo.data;

    const response_moneda = await axios.post(
      `${process.env.VUE_APP_URL_BASE}/acceso/v2.0/simulacion/reclamos/getMoneda`,
      {},
      {
        headers: {
          "content-type": "application/json",
          Authorization: "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
        },
      }
    );
    this.selectMoneda = response_moneda.data;

    const response_viares = await axios.post(
      `${process.env.VUE_APP_URL_BASE}/acceso/v2.0/simulacion/reclamos/getViares`,
      {},
      {
        headers: {
          "content-type": "application/json",
          Authorization: "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
        },
      }
    );
    this.selectViares = response_viares.data;

    const response_reqres = await axios.post(
      `${process.env.VUE_APP_URL_BASE}/acceso/v2.0/simulacion/reclamos/getReqres`,
      {},
      {
        headers: {
          "content-type": "application/json",
          Authorization: "Basic YXBpYWNjYWNjOlZWMWc4SnZrN3A0djVoVFBSNFZj",
        },
      }
    );
    this.selectReqres = response_reqres.data;

    //console.log(response_sedrec.data);
  },
};
</script>

<style>
</style>
